const updateBlockType = ({
  pageState: { editorBlocks },
  data: { blockId, blockType, data }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        data: JSON.parse(JSON.stringify(data)),
        type: blockType,
        editor: null,
        isEdited: true,
        updatedAt: null
      }
    },
    editorHeaderStatus: 'saving'
  };
};

export default updateBlockType;
